import type { QueryClient } from '@tanstack/react-query';

let authSessionVersion = 0;

export function getAuthSessionVersion(): number {
  return authSessionVersion;
}

export function createAuthQueryCacheInvalidator(queryClient: QueryClient): (accessToken: string | null) => void {
  let previousAccessToken: string | null | undefined;

  return (accessToken) => {
    if (previousAccessToken !== undefined && previousAccessToken !== accessToken) {
      queryClient.clear();
      authSessionVersion += 1;
    }
    previousAccessToken = accessToken;
  };
}
